import Vue from 'vue'
import VueRouter from 'vue-router'
import Acl from 'vue-acl'

Vue.use(VueRouter)
let router = new VueRouter({
  mode: 'history',

  routes: [
    // unauthenticated
    {
      name: 'login',
      path: '/',
      component: require('@components/views/login/login.vue').default,
      meta: { permission: 'any' }
    },

    {
      name: 'registro',
      path: '/registro',
      component: require('@components/views/login/registro.vue').default,
      meta: { permission: 'any' },
      fail: '/'
    },

    // secured
    {
      name: 'home',
      path: '/home',
      component: require('@components/views/home/home.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'realizarPedido',
      path: '/RealizarPedido',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },


    {
      name: 'pedido',
      path: '/Pedido',
      component: require('@components/views/pedido/pedido.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'estadoPedido',
      path: '/EstadoPedido',
      component: require('@components/views/estadoPedido/estadoPedido.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'pedidoCms',
      path: '/PedidoCms',
      component: require('@components/views/estadoPedido/pedidoCms.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'promociones',
      path: '/Promociones',
      component: require('@components/views/promociones/promociones.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'descuentos',
      path: '/Descuentos',
      component: require('@components/views/descuentos/descuentos.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'reload',
      path: '/reload',
      component: require('@components/views/pedido/reload.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'configuracion',
      path: '/Configuracion',
      component: require('@components/views/home/configuracion.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    },

    {
      name: 'cuentaCorriente',
      path: '/CuentaCorriente',
      component: require('@components/views/cuentaCorriente/cuentaCorriente.vue').default,
      meta: { permission: 'user' },
      fail: '/'
    }



    // {
    //   path: '',
    //   component: require('@components/layouts/root.vue').default,
    //   meta: { permission: 'user' },
    //   children: [
    //     // outside a project
    //     {
    //       path: '',
    //       component: require('@components/layouts/outside.vue').default,
    //       children: []
    //     },

    //     // inside a project
    //     {
    //       path: '',
    //       component: require('@components/layouts/inside.vue').default,
    //       children: []
    //     }
    //   ]
    // }
  ]
})

Vue.use(Acl, {
  router,
  init: 'any'
})

export default router



// WEBPACK FOOTER //
// ./src/config/router.js